/** @format */

export default class FormsValidation {
	constructor() {
		this.instance = self;
	}

	static init() {
		const self = new FormsValidation();
		self.attachEvents();
	}

	attachEvents() {
		const self = this;

		// When a select field changes from the first default value, remove empty class
		// $(document).on("change", "select", function () {
		// 	$(this).removeClass("is-empty");
		// });

		// $(document).on("input", ".form-control", function () {
		// 	self.addControlActiveClass($(this));
		// });

		// Only want to check the validity on change
		$(document).on("change", ".form-control, .form-check-input", function () {
			self.toggleFormControlClasses($(this)).toggleErrorMessages($(this));
		});

		// On blur event gets triggered when user presses done on keyboard - needed only on tablet/mobile
		if ($(window).width() < 992) {
			$(document).on("blur", ".form-control, .form-check-input", function () {
				self.toggleFormControlClasses($(this)).toggleErrorMessages($(this));
			});
		}

		// Custom JS for hz forms with error messages being added - need to pos abs the message - add the required height depending on the form height and the error message height
		if ($(window).width() > 1199) {
			$(document).on(
				"ajaxError",
				".mod-horizontal-dt [data-request-validation]",
				function (event, context, statusText, something, jqXHR) {
					var $form = $(this);

					// Only add extra height if doesn't have class
					if (!$form.hasClass("mod-hz-form-pos-abs-error-messages")) {
						$form.addClass("mod-hz-form-pos-abs-error-messages");

						// Step 1: Get height of the form
						const formHeight = $form.outerHeight();

						// Step 2: Loop through all .input-error-message and get the tallest height value
						let tallestErrorHeight = 0;
						$form.find(".input-error-message").each(function () {
							let errorHeight = $(this).outerHeight();
							if (errorHeight > tallestErrorHeight) {
								tallestErrorHeight = errorHeight;
							}
						});

						// Step 3: Add height of form to the height of the tallest input error message
						const totalHeight = formHeight + tallestErrorHeight;

						// Step 4: Add inline min-height style with this value
						$form.css("min-height", totalHeight + "px");
					}
				}
			);

			$(document).on(
				"change",
				".mod-horizontal-dt [data-request-validation] .form-control",
				function () {
					// Error messages are removed on change - unset the height

					// Remove min height set on form on ajax error for hz form
					$(this)
						.parents(".mod-hz-form-pos-abs-error-messages")
						.css("min-height", "unset");

					// Remove class
					$(this)
						.parents(".mod-hz-form-pos-abs-error-messages")
						.removeClass("mod-hz-form-pos-abs-error-messages");
				}
			);
		}

		// Prevent native HTML5 validation bubbles from showing
		$("form[data-request-validation]").attr("novalidate", "novalidate");

		$(document).on("ajaxComplete", function () {
			$("form[data-request-validation]").attr("novalidate", "novalidate");
		});

		$(document).on("focus", "form[data-request-validation] .form-control", function () {
			$(this).parents("form").attr("novalidate", "novalidate");
		});

		$(document).on("click", "form[data-request-validation] [type='submit']", function () {
			$(this).parents("form").attr("novalidate", "novalidate");
		});

		// Submit validation handling
		$(document).on("submit", "form[data-request-validation]", function (e) {
			const $form = $(this);
			let formIsValid = true;

			$form.find(".form-control, .form-check-input").each(function () {
				self.toggleFormControlClasses($(this)).toggleErrorMessages($(this));
				if (!$(this).get()[0].checkValidity()) {
					formIsValid = false;
				}
			});

			if (!formIsValid) {
				e.preventDefault();
				e.stopPropagation();
				return false;
			}
		});
	}

	// addEmptyClassToFormControls() {
	// 	const self = this;

	// 	if ($(".form-control").length > 0) {
	// 		$(".form-control").addClass("is-empty");
	// 	}

	// 	return self;
	// }

	// toggleFormSubmitButton($button) {
	// 	const self = this,
	// 		$form = $button.parents("form"),
	// 		form = $form[0];

	// 	// enable or disable a form's submit button based on the form's validity
	// 	if (form) {
	// 		// true if the form is valid according to the constraints set on its input elements (e.g., required fields, pattern matches, etc.).
	// 		if (form.checkValidity()) {
	// 			$button.removeClass("is-disabled").removeAttr("disabled");
	// 		} else {
	// 			$button.addClass("is-disabled").attr("disabled", "disabled");
	// 		}
	// 	}

	// 	return self;
	// }

	// toggleElementsFormValid($el) {
	// 	const self = this,
	// 		$form = $el.parents("form"),
	// 		form = $form[0];

	// 	if (form) {
	// 		if ($form[0].checkValidity()) {
	// 			$el.removeClass("is-disabled");
	// 		} else {
	// 			$el.addClass("is-disabled");
	// 		}
	// 	}

	// 	return self;
	// }

	// addControlActiveClass($input) {
	// 	const self = this;

	// 	console.log("addControlActiveClass - input event ");

	// 	// If no val add empty class
	// 	if ($input.val() === "") {
	// 		$input.addClass("is-empty");
	// 		$input.removeClass("is-active");
	// 	} else {
	// 		$input.removeClass("is-empty");
	// 		// Add is-active class when has a value - invalid style set if doesn't pass validation
	// 		$input.addClass("is-active");
	// 	}

	// 	// Remove erroneous on change
	// 	if ($input.hasClass("is-erroneous")) {
	// 		$input.removeClass("is-erroneous");
	// 	}

	// 	// Always hide error message when is active - then will check validity and show message
	// 	let errorMessage = $input.parent(".form-group").find(".input-error-message");

	// 	if (errorMessage.length > 0) {
	// 		errorMessage.remove();
	// 	}

	// 	return self;
	// }

	toggleFormControlClasses($input) {
		const self = this;

		// console.log("toggleFormControlClasses - onChange ");

		// On change of input - always remove the is-active class - we are no longer typing
		$input.removeClass("is-active");

		// If no val add empty class
		if ($input.val() === "") {
			$input.addClass("is-empty");
		} else {
			$input.removeClass("is-empty");
		}

		// Remove erroneous on change
		if ($input.hasClass("is-erroneous")) {
			$input.removeClass("is-erroneous");
		}

		return self;
	}

	toggleErrorMessages($field) {
		const self = this,
			value = $field.val(),
			type = $field.attr("type"),
			nameAttr = $field.attr("name") || "",
			name = nameAttr.replace(/_/g, " ");

		// Remove min height set on form on ajax error for hz form
		$field.parents(".mod-hz-form-pos-abs-error-messages").css("min-height", "unset");

		// Remove class
		$field
			.parents(".mod-hz-form-pos-abs-error-messages")
			.removeClass("mod-hz-form-pos-abs-error-messages");

		// Clear all messages - removes duplicate error messages
		$field.parents(".form-group").find(".input-error-message").remove();

		let valid = $field.get()[0].checkValidity();

		if ($field.attr("id") == "form-name" || $field.attr("id") == "form-surname") {
			if (!this.onlyLetters(value)) {
				valid = false;
				$field[0].setCustomValidity("Must only contain letters");
			} else if (value.length < 2) {
				valid = false;
				$field[0].setCustomValidity("Must contain more than one letter");
			} else {
				$field[0].setCustomValidity(""); // remove custom - is valid now
				valid = true;
			}
		}

		if ($field.hasClass("js-custom-validate-phone-number")) {
			if (!this.isValidPhoneNumber(value)) {
				// console.log("isValidPhoneNumber = FALSE");
				valid = false;
				$field[0].setCustomValidity("Please enter a valid UK phone number"); // native invalid popup message
			} else {
				// console.log("isValidPhoneNumber = TRUE");
				$field[0].setCustomValidity("");
				valid = true;
			}
		}

		let message;

		// console.log(valid, name);

		if (!valid) {
			if (nameAttr == "phone_number") {
				message = "Please enter a valid UK phone number"; // custom message for input-error-message div
			} else if (name == "business_type") {
				message = "Please enter a valid business type.";
			} else if (name == "turnover_amount") {
				message = "Please enter a valid turnover amount.";
			} else if (name == "annual_net_profit") {
				message = "Please enter a valid annual net profit.";
			} else if (type == "email") {
				message = "Please make sure your email format is correct";
			} else if ($field.attr("id") == "form-name" || $field.attr("id") == "form-surname") {
				if (value.length < 2) {
					message = "Must contain more than one letter";
				} else {
					message = "The " + name + " field is required";
				}
				if (!this.onlyLetters(value)) {
					message = "Must only contain letters";
				}
			} else if (nameAttr == "postcode") {
				message = "Please enter a valid postcode.";
			} else {
				message = "The " + name + " field is required";
			}

			if (type === "checkbox") {
				$field
					.parent(".form-check")
					.append('<div class="input-error-message">' + message + "</div>");
			} else if (type === "radio") {
				$field
					.parents(".form-group")
					.append('<div class="input-error-message">' + message + "</div>");
			} else if ($field.is("select")) {
				$field
					.parents(".form-group")
					.append('<div class="input-error-message">' + message + "</div>");
				$field.parents(".form-group").find(".select2-container").addClass("is-erroneous");
			} else {
				$field.after('<div class="input-error-message">' + message + "</div>");
			}
		} else {
			$field.parents(".form-group").find(".input-error-message").remove(); // if $field is valid - make sure no input-error-message elems
		}

		return self;
	}

	// validateIfEmptyInput($input) {
	// 	const self = this;

	// 	const value = $input.val();

	// 	// Check if the field is required
	// 	if ($input.prop("required")) {
	// 		// Check if the field is null or empty
	// 		if ($input.val() === null || value.length < 1) {
	// 			// Set custom validity message
	// 			$input[0].setCustomValidity("This field is required.");

	// 			$input.addClass("is-empty");

	// 			// Toggle form control classes and error messages
	// 			self.toggleErrorMessages($input);

	// 			// Now we have set field to invalid for toggleErrorMessages function - clear our custom validity
	// 			$input[0].setCustomValidity("");
	// 		}
	// 	}
	// }

	validateEmailPhoneInput($el) {
		const self = this,
			$input = $el,
			inputValue = $input.val();

		// console.log("On keyup or change");
		// console.log(inputValue);

		// Regular expression for email validation
		const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
		// Regular expression for phone number validation (optional plus sign, 9 to 12 digits)
		const phonePattern = /^[+]?[0-9]{9,12}$/;

		if (inputValue === "") {
			// console.log("Invalid input");
			$input.removeClass("is-erroneous");
			$input.addClass("is-empty");
			$input.next().hide();
		} else if (emailPattern.test(inputValue) || phonePattern.test(inputValue)) {
			// Input is valid
			// console.log("Valid input");
			$input.removeClass("is-erroneous");
			$input.next().show();
		} else {
			// console.log("Invalid input");
			$input.addClass("is-erroneous");
			$input.next().hide();
		}

		return self;
	}

	validatePhoneInput($field) {
		const value = $field.val();

		let valid = $field.get()[0].checkValidity();

		if ($field.hasClass("js-custom-validate-phone-number")) {
			if (!this.isValidPhoneNumber(value)) {
				// console.log("isValidPhoneNumber = FALSE");
				valid = false;
				$field[0].setCustomValidity("Please enter a valid UK phone number"); // native invalid popup message
			} else {
				// console.log("isValidPhoneNumber = TRUE");
				$field[0].setCustomValidity("");
				valid = true;
			}
		}
	}

	isValidPhoneNumber(value) {
		const phonePattern = /^[+]?[0-9 ]{9,15}$/;
		return phonePattern.test(value);
	}

	onlyLetters(input) {
		let regex = /^[A-Za-z]*$/;
		return regex.test(input);
	}
}
